/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchEventOptionsResponseOptionsEventTypes,
  FetchEventOptionsResponseOptionsEventTypesFromJSON,
  FetchEventOptionsResponseOptionsEventTypesToJSON,
  FetchEventOptionsResponseOptionsLeadershipTrainingRoles,
  FetchEventOptionsResponseOptionsLeadershipTrainingRolesFromJSON,
  FetchEventOptionsResponseOptionsLeadershipTrainingRolesToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchEventOptionsResponseOptions
 */
export interface FetchEventOptionsResponseOptions {
  /**
   * Array of available event types that can be used when creating or filtering events.
   * @type {Array<FetchEventOptionsResponseOptionsEventTypes>}
   * @memberof FetchEventOptionsResponseOptions
   */
  eventTypes: Array<FetchEventOptionsResponseOptionsEventTypes>
  /**
   * Array of leadership training roles available for assignment or display.
   * @type {Array<FetchEventOptionsResponseOptionsLeadershipTrainingRoles>}
   * @memberof FetchEventOptionsResponseOptions
   */
  leadershipTrainingRoles?: Array<FetchEventOptionsResponseOptionsLeadershipTrainingRoles>
}

export function FetchEventOptionsResponseOptionsFromJSON(
  json: any
): FetchEventOptionsResponseOptions {
  return FetchEventOptionsResponseOptionsFromJSONTyped(json, false)
}

export function FetchEventOptionsResponseOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchEventOptionsResponseOptions {
  if (json === undefined || json === null) {
    return json
  }
  return {
    eventTypes: (json['eventTypes'] as Array<any>).map(
      FetchEventOptionsResponseOptionsEventTypesFromJSON
    ),
    leadershipTrainingRoles: !exists(json, 'leadershipTrainingRoles')
      ? undefined
      : (json['leadershipTrainingRoles'] as Array<any>).map(
          FetchEventOptionsResponseOptionsLeadershipTrainingRolesFromJSON
        ),
  }
}

export function FetchEventOptionsResponseOptionsToJSON(
  value?: FetchEventOptionsResponseOptions | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    eventTypes: (value.eventTypes as Array<any>).map(
      FetchEventOptionsResponseOptionsEventTypesToJSON
    ),
    leadershipTrainingRoles:
      value.leadershipTrainingRoles === undefined
        ? undefined
        : (value.leadershipTrainingRoles as Array<any>).map(
            FetchEventOptionsResponseOptionsLeadershipTrainingRolesToJSON
          ),
  }
}
